<template>
  <div class="empty-wrap">
    <!-- verticalM  -->
    <div class="empty-box">
      <!--  verticalM-box  -->
      <img :src="imgpath" />
      <p>{{ emptytext }}</p>
      <mu-raised-button
        v-if="btntext"
        :label="btntext"
        @click="doUrl(btnurl)"
      />
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  props: {
    imgpath: String, //图片路径
    emptytext: String, //文字提示
    btntext: [String, Boolean], //按钮文字
    btnurl: String, //按钮跳转链接
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    doUrl(url) {
      location.href = url;
      // this.$router.push({
      // 		path: url
      // 	})
    },
  },
  created() {
    //console.log(this.btntext)
  },
};
</script>
<style lang="scss" rel="stylesheet/scss">
@import "src/common/sass/mixin.scss";
.empty-wrap {
  /*height: 100%;*/
  .empty-box {
    width: 100%;
    text-align: center;
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    img {
      width: 2.75rem;
    }
    p {
      @include font-dpr(16px);
      margin-top: 0.3rem;
      margin-bottom: 0.8rem;
      color: #7e7e7e;
    }
    .mu-raised-button {
      min-width: 2.5rem;
      height: 1rem;
      border: 1px solid #979797;
      background: rgba(255, 255, 255, 0);
      border-radius: 0.125rem;
      line-height: 1rem;
      color: #4a4a4a;
      @include font-dpr(14px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// empty.vue?44315053